<template>
  <v-dialog
    scrollable
    v-model="showLogin"
    max-width="600px"
    :fullscreen="this.$vuetify.breakpoint.xsOnly"
    style="z-index: 550;"
  >
    <template v-slot:activator="{ on }">
      <span
        v-if="isTextButton"
        class="primary--text text-body-1 font-weight-bold"
        @click="onLoginClick"
        style="cursor: pointer;"
      >
        login
      </span>
      <v-btn
        v-else
        outlined
        :disabled="$route.name === 'Login'"
        :class="$vuetify.breakpoint.mdAndDown ? 'px-2' : ''"
        v-on="on"
        @click="onLoginClick"
        color="primary"
        id="btn_login_dialog"
        class="ml-1 caption py-3"
      >
        {{ $t("login") }}
      </v-btn>
    </template>
    <v-card class="colorDominant" v-click-outside="closeDialogOnMouseAway">
      <v-toolbar absolute class="transparent elevation-0" height="64">
        <v-btn
          fab
          depressed
          class="transparent"
          small
          @click="closeDialog"
          tabindex="5"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <!-- <v-toolbar-title>                    
          {{ title }}
        </v-toolbar-title>-->
      </v-toolbar>
      <v-card-text class="pa-0">
        <loginForm :urlRedirect="urlRedirect" @closeDialog="closeDialog" />
      </v-card-text>
      <template
        v-if="
          $permissions().linkAuthAgent &&
            !$store.state.showMigrationUserLoginMessage
        "
      >
        <v-divider></v-divider>
        <div class="pa-4 text-center">
          <v-btn depressed text link :href="agentAuth" target="_blank">
            {{ $t("loginAsACollaborator") }} &nbsp;
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>
<script>
import loginForm from "@/components/login";
export default {
  name: "dialogLogin",
  components: {
    loginForm,
  },
  props: ["urlRedirect", "isTextButton"],
  data: () => ({
    title: "Login",
    showLogin: false,
    agentAuth: "",
  }),

  mounted() {
    let domain = this.$domain();
    let lang = localStorage.getItem("language");
    if (domain == "sys") {
      this.agentAuth = `https://agent.sys.bet/page/login/auth/sys?lang=${lang}`;
    } else if (domain == "homolog-user") {
      this.agentAuth = `https://homolog-agent.sga.bet/page/login/auth/homolog?lang=${lang}`;
    } else {
      this.agentAuth = `https://agent.sga.bet/page/login/auth/${domain}?lang=${lang}`;
    }
  },

  watch: {
    openLoginDialog(val) {
      this.showLogin = val;
    },
  },

  computed: {
    openLoginDialog() {
      return this.$store.state.openLoginDialog;
    },
  },

  methods: {
    onLoginClick() {
      const onJogoDeOuroDomains = ["bet24hs", "chutaco", "sportebet", "soccer888", "nordestefutebol", "apostamaster", "betclub7", "attack"];

      if (onJogoDeOuroDomains.includes(this.$domain())) {
        window.location = "https://jogodeouro.bet/pt/sports#/overview";
      } else {
        this.showLogin = true;
      }
    },
    closeDialog() {
      this.showLogin = false;
      this.$store.commit("setLoginDialog", false);
      this.$store.state.showMigrationUserLoginMessage = false;
    },
    closeDialogOnMouseAway() {
      this.$store.state.showMigrationUserLoginMessage = false;
    },
  },
};
</script>
